/**
 * Plugin: legacy-api.client.js
 *
 * Instancia um cliente axios dedicado para a API legada (mobi-admin-ui).
 * Injeta o token de autenticação do localStorage automaticamente.
 * Disponível via useNuxtApp().$legacyApi
 */
import axios from 'axios'
import { defineNuxtPlugin, useRuntimeConfig } from 'nuxt/app'
import { useLegacyAuthStore } from '~/stores/legacyAuth'
import { useAppStore } from '~/stores/app'

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()

  const baseURL = config.public.LEGACY_API_URL || 'https://hml.gateway.mobiin.pt'

  const legacyApi = axios.create({
    baseURL,
    timeout: 30000,
  })

  // Interceptor: injeta o token em todas as requisições
  legacyApi.interceptors.request.use((axiosConfig) => {
    const token = localStorage.getItem('legacy_access_token')
    if (token) {
      axiosConfig.headers['Authorization'] = `Bearer ${token}`
    }
    return axiosConfig
  })

  // Interceptor de resposta: trata erros 401 globalmente
  legacyApi.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        localStorage.removeItem('legacy_access_token')
        localStorage.removeItem('legacy_login')
        localStorage.removeItem('legacy_permissions')
        const appStore = useAppStore(nuxtApp.$pinia)
        appStore.setSession2(false)
      }
      return Promise.reject(error)
    }
  )

  // Restaura sessão legada do localStorage após F5
  const legacyAuthStore = useLegacyAuthStore(nuxtApp.$pinia)
  const appStore = useAppStore(nuxtApp.$pinia)
  legacyAuthStore.init()
  if (legacyAuthStore.isAuthenticated) {
    appStore.setSession2(true)
  }

  return {
    provide: {
      legacyApi,
    },
  }
})
